(function() {
'use strict';

angular
    .module('core')
    .directive('lightboxMap', lightboxMap);

function lightboxMap(maps, broker) {
    const template = `
        <lightbox class="lightbox-map" show="showModal" busy="loadingMap" close="close()">
            <div class="map-canvas"> </div>
        </lightbox>
    `;

    return {
        restrict: 'E',
        scope: {
            zoom: '@',
            dealsMode: '@'
        },
        template,
        link
    };

    function link(scope, el) {
        let map = null;
        let data = {};

        broker.subscribe('lightboxMap', 'MAPLIGHTBOX', e => {
            data = e.data;
            maps.loadScript(initializeMap);
        });

        function initializeMap() {
            displayModal(true);
            displayLoader(true);

            let centre = {
                lat: data.hotel.lat || data.hotel.Latitude,
                lon: data.hotel.lon || data.hotel.Longitude,
            };

            maps.getLocations(null, centre, !!scope.dealsMode, data.showInfoWindow)
                .then(result => { populateMap(result); });
        }

        function populateMap(mapInfo) {
            let selectedMarker = null;
            if (mapInfo.markers) {
                selectedMarker = _.find(mapInfo.markers, x => x.estabId === data.hotel.Id);
            }

            const canvas = el.find('.map-canvas');
            const zoom = parseInt(scope.zoom);

            const mapRendered = scope.$watch(() => canvas.height(), v => {
                if (v && v !== 100) {
                    map = maps.buildMap(
                        canvas[0],
                        mapInfo.centre,
                        zoom,
                        selectedMarker
                    );
                    map = maps.addMarkers(map, mapInfo.markers, selectedMarker, mapInfo.infoWindow);

                    mapRendered();
                }
            });

           scope.close = onClose;
           displayLoader(false);
        }

        function onClose() {
            displayModal(false);
        }

        function displayModal(value) {
            scope.showModal = value;
        }

        function displayLoader(value) {
            scope.loadingMap = value;
        }

        scope.$on('$destroy', () => {
            broker.unsubscribe('lightboxMap');
        });
    }
}
})();
